import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NgClass } from '@angular/common';

@Component({
    selector: 'plp-components-shipping-option-button',
    imports: [NgClass],
    templateUrl: './shipping-option-button.component.html',
    styleUrls: ['./shipping-option-button.component.scss']
})
export class ShippingOptionButtonComponent {
	@Input() shippingOption;
	@Input() selected: boolean;
	@Input() disabled: boolean;
	@Output() selectedOption = new EventEmitter();

	emitSelctedOption() {
		this.selectedOption.emit();
	}
}
